import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { HttpError } from '@microsoft/signalr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { mostrarSwalConfirm, mostrarSwalError, mostrarSwalToast } from 'src/app/core/Funciones/funciones';
import { AccesoDatosService } from 'src/app/core/services/acceso-datos.service';
import { NomiExpressApiService } from 'src/app/core/services/NomiExpress.api.service';
import { ReconocimientoCFService } from 'src/app/core/services/reconocimiento-cf.service';
import { AccesoCF_RespuestaRecognize_Respuesta, IAccesoEmpleadoRF, IEmpleadoRF, nuevoEmpleadoRF } from 'src/app/models/accesoCF';
import { AccesoExpress, imagenMinPixeles, validarReconocimiento } from 'src/app/models/accesoExpress';
import { IEmpleados, nombreEmpleado, nuevoEmpleado } from 'src/app/models/empleados';
import { IEmpresa } from 'src/app/models/empresa';
import { IRespuestaChecker } from 'src/app/models/resultadoActualiza';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-empleado-verificar',
  templateUrl: './empleado-verificar.component.html',
  styleUrls: ['./empleado-verificar.component.scss']
})
export class EmpleadoVerificarComponent implements OnInit {
  public camaraAncho: number = 100;
  public camaraAlto: number = 100;
  public infoCamara: string = '';
  public datosEmpleado: string | undefined = undefined;
  public accesoExpress!: AccesoExpress;
  public facingMode: string = '-'; // 'user'; // 'environment'
  private trigger: Subject<any> = new Subject();
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();
  public webcamImage!: WebcamImage;
  public esDebugger: boolean = false;
  public datosRF: IAccesoEmpleadoRF = nuevoEmpleadoRF();
  public cargando: boolean = false;
  private ultimaFoto: string | undefined = undefined;
  public comparaciones: { fotoRegistrada: string, idFotoRegistrada: string, fotoTomada: string, similitud: string, nombrePunto: string }[] = [];
  public mostrarFotoTomada: boolean = false;
  public idFotoSeleccionada: string = '';
  public fotoSeleccionada: string = '';
  public modalRef?: BsModalRef;
  public mostrarDatosError: boolean = false;
  public empleadoActual: string = '';
  public similitudEmpleadoActual: string = '';
  public similitudGuardar: number = 0;
  public respuestaGuardar: AccesoCF_RespuestaRecognize_Respuesta | undefined = undefined;
  public fotoTomadaGuardar: string = '';
  public verificacionContinua: boolean = false;
  private intervalId: any;
  public aplicarEstilos: boolean = false;
  public empleados: IEmpleados[] = [];
  public empleadoSeleccionado: IEmpleados | undefined = undefined;
  public datosEmpleadoCamara: IEmpleados | undefined = undefined;

  @Input()
  public empleado: IEmpleados = nuevoEmpleado();

  @Input()
  public fotoTomada: string = '';

  @Input()
  public esModoVerificaIncidencia: boolean = false;

  @Output()
  public mostrarEmpleados = new EventEmitter<boolean>();

  @Output()
  public cerrarVerificarFoto = new EventEmitter<void>();

  constructor(
    private nomiExpressApi: NomiExpressApiService,
    private accesoDatosService: AccesoDatosService,
    private reconocimientoFacialService: ReconocimientoCFService,
    private modalService: BsModalService,
  ) {
  }

  private cargarEmpleado(realizarVerificacion: boolean) {
    this.datosRF = nuevoEmpleadoRF();
    if (this.empleado.id == '999') return;
    this.accesoDatosService.empleadoObtenerRF_id(+this.empleado.id).subscribe(
      (empleado: IEmpleadoRF) => {
        this.datosRF = empleado.empleadoRF;
        this.cargando = false;
        this.accesoDatosService.empresaObtener().subscribe(
          (empresa: IEmpresa) => {
            if (!empresa.apiKeyCF) {
              mostrarSwalError('Reconocimiento facial', 'La empresa no esta registrada en los servidores de Reconocimiento Facial, favor de comunicarse a soporte para que sea solucionado este problema');
              return;
            }
          });
        if (realizarVerificacion && this.fotoTomada) {
          const base64Data = this.fotoTomada.includes('base64,') ? this.fotoTomada.split('base64,')[1] : this.fotoTomada;
          this.verificarEmpleado(base64Data);
        }
    }, (error) => {
      console.error(error);
      let err: string = error.error;
      this.accesoDatosService.logAgrega2("Error al cargar los datos de los empleados RF. " + err);
      mostrarSwalError('Reconocimiento facial', 'Error al cargar los datos del empleado RF');
      this.cargando = false;
    });
  }

  public cargarEmpleados() {
    this.accesoDatosService.empleadosListado().subscribe(
      (empleados: IEmpleados[]) => {
        this.empleados = empleados;
        this.aplicarFiltros();
        this.empleados.forEach(empleado => {
          (empleado as any)['nombreCompleto'] = `${empleado.nombre} ${empleado.paterno ? empleado.paterno : ''} ${empleado.materno ? empleado.materno : ''}`;
        });
        this.cargando = false;
      },
      (error) => {
        this.accesoDatosService.logAgrega2("Error al cargar los datos de los empleados");
        console.error(error);
        this.empleados = [];
        this.cargando = false;
      }
    );
  }

  public aplicarFiltros() {
    this.empleados.sort((a, b) =>(a.nombre + a.paterno).toLowerCase().localeCompare((b.nombre + b.paterno).toLowerCase()));
  }

  public limpiarFiltro() {
    this.empleadoSeleccionado = undefined;
  }

  public nombreCompleto(empleado: IEmpleados) {
    return nombreEmpleado(empleado);
  }

  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.accesoExpress.facingMode && this.accesoExpress.facingMode !== '') {
        if (this.facingMode != this.accesoExpress.facingMode) {
          // this.ponerTxtEnConsola(`>>>>>>>>>>>>>>>>>>>>>>>>> facingMode: ${this.accesoExpress.facingMode}`)
          this.facingMode = this.accesoExpress.facingMode;
        }
        result.facingMode = { ideal: this.accesoExpress.facingMode };
    }
    return result;
  }

  public get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  public mostrarNombreCompleto() {
    return nombreEmpleado(this.empleado);
  }

  private limpiarDatosDeToma() {
    this.fotoTomada = '';
    this.fotoTomadaGuardar = '';
    this.mostrarFotoTomada = false;
    this.datosEmpleado = undefined;
    this.empleadoActual = '';
    this.similitudEmpleadoActual = '';
    this.comparaciones = [];
  }

  public iniciarTomaAutomatica() {
    this.infoCamara = `Iniciando toma automática...`;
    this.cargarEmpleado(false);
    this.limpiarDatosDeToma();
    this.tomarFoto();
  }

  public tomarFoto() {
    setTimeout(() => {
      this.trigger.next();
    }, 1000);
    this.infoCamara = 'Tomando foto...';
  }

  public captureImg(webcamImage: WebcamImage): void {
    this.ultimaFoto = webcamImage!.imageAsBase64;
    this.reconocimientoFacialService.empleadoReconocerRostro(this.ultimaFoto).subscribe((respuesta: AccesoCF_RespuestaRecognize_Respuesta) => {
      this.respuestaGuardar = respuesta;
      this.similitudGuardar = respuesta.subjects.similarity;
      if (respuesta.subjects.similarity < 0.5) { // no hay rostro en la imagen
        this.infoCamara = 'Sin rostro';
        this.ultimaFoto = undefined;
        return;
      }
      if (respuesta.subjects.similarity < 0.9 ) { // no hay un rostro reconocido
        this.infoCamara = 'No se detecta rostro';
        return;
      }

      if (respuesta.subjects.similarity < this.accesoExpress.validarReconocimiento) { // empleado no reconocido
        this.infoCamara = 'Empleado no reconocido';
        this.ultimaFoto = undefined;
        return;
      }

      let box_x: number = respuesta.box.x_max - respuesta.box.x_min;
      let box_y: number = respuesta.box.y_max - respuesta.box.y_min;

      if (box_x < imagenMinPixeles || box_y < imagenMinPixeles) {
        let txt: string = `Imagen demasiado pequeña.`;
        this.infoCamara = txt;
        this.ultimaFoto = undefined;
        return;
      }

      if (!this.ultimaFoto) {
        this.infoCamara = 'Imagen nula';
        return;
      }

      this.verificarEmpleado(this.ultimaFoto);
    }, (err: HttpError) => {
      this.infoCamara = 'Error al cargando información del empleado';
      this.ultimaFoto = undefined;
      mostrarSwalError('Error al capturar imagen', err.message)
    });
  }

  public verificarEmpleadoSeleccionado() {
    if (!this.fotoTomada) {
      mostrarSwalError('Error', 'No hay una foto tomada para mostrar');
      return;
    }
    if (!this.empleadoSeleccionado) {
      mostrarSwalError('Error', 'No hay un empleado seleccionado para verificar');
      return;
    }
    this.empleado = this.empleadoSeleccionado;
    this.cargarEmpleado(true);
  }

  private verificarEmpleado(foto64: string): void {
    this.similitudEmpleadoActual = '';
    this.aplicarEstilos = false;
    this.infoCamara = 'Reconociendo empleado';
    this.datosEmpleado = undefined;
    this.reconocimientoFacialService.empleadoReconocer(foto64).subscribe(
      (respuesta: AccesoCF_RespuestaRecognize_Respuesta) => {
        this.infoCamara = 'Reconociendo empleado....';
        let similitud: number = respuesta.subjects.similarity;
        let idEmpleado: number = +respuesta.subjects.subject;

        if (similitud < this.accesoExpress.validarReconocimiento || idEmpleado == 0) {
          this.infoCamara = 'Empleado no reconocido.';
        }

        const empleado = this.nomiExpressApi.obtenerEmpleado(idEmpleado.toString());

        if (!empleado) {
          this.aplicarEstilos = true;
          this.mostrarDatosError = false;
          this.infoCamara = 'Empleado no registrado';
        } else {
          this.datosEmpleadoCamara = empleado;
          if (this.verificacionContinua) {
            if (idEmpleado === +this.empleado.id) {
              this.aplicarEstilos = false;
              this.infoCamara = `Empleado reconocido: ${nombreEmpleado(empleado)} — Similitud: ${(similitud * 100).toFixed(2)}% (${this.esDebugger ? empleado.id : ''})`;
            } else {
              this.aplicarEstilos = true;
              this.infoCamara = `Empleado reconocido: ${nombreEmpleado(empleado)}`;
            }
          } else {
            // mandar información de que empleado reconocido y si no es el mismo que el empleados actual poner mensaje en rojo
            if (idEmpleado !== +this.empleado.id) {
              this.mostrarDatosError = true;
              this.infoCamara = 'Empleado reconocido, pero no coincide con el empleado actual';
              this.datosEmpleado = `Empleado reconocido: ${nombreEmpleado(empleado)} — Similitud: ${(similitud * 100).toFixed(2)}%`;
              this.empleadoActual = `Empleado actual: ${nombreEmpleado(this.empleado)}`;
            } else {
              this.mostrarDatosError = false;
              this.datosEmpleado = `Empleado reconocido: ${nombreEmpleado(empleado)} Similitud: ${(similitud * 100).toFixed(2)}% (${this.esDebugger ? empleado.id : ''})`;
            }
          }
        }

        // ya sabes que empleado es, ahora verificamos contra las fotos registradas
        this.compararContraFotosRegistradas(foto64);
      }, (err: Error) => {
        this.infoCamara = 'Error al cargando información del empleado';
        this.ultimaFoto = undefined;
        let txt: string = err.message;
        console.error('Error en el reconocimiento facial:', txt);
      });
  }

  private compararContraFotosRegistradas(foto64: string) {
    this.infoCamara = 'Iniciando reconocimiento facial...';
    this.comparaciones = [];
    const esContinua = this.verificacionContinua;
    const loopLength = esContinua ? 1 : this.datosRF.datos.length;

    for (let i = 0; i < loopLength; i++) {
      const idCf = this.datosRF.datos[i].idCf;
      const fotoRef = this.datosRF.datos[i].datos;
      const fotoRegistrada = fotoRef.startsWith('data:image') ? fotoRef : `data:image/jpeg;base64,${fotoRef}`;
      const fotoCapturada = foto64.startsWith('data:image') ? foto64 : `data:image/jpeg;base64,${foto64}`;

      this.fotoTomadaGuardar = foto64;

      this.reconocimientoFacialService.empleadoReconocimientoFacialValidar(idCf, foto64).subscribe(
        (resultadoVerificar: AccesoCF_RespuestaRecognize_Respuesta) => {
          const similitud = resultadoVerificar.subjects.similarity;
          const porcentaje = (similitud * 100).toFixed(2);
          const nombrePuntoDeAcceso: string = this.datosRF.datos[i].nombrePuntoDeAcceso || this.datosRF.datos[i].idPuntoAcceso || this.datosRF.datos[i].deviceId || 'Desconocido';

          if (similitud === 0) {
            this.infoCamara = `Imagen no verificada ${foto64}`;
            return;
          }

          if (esContinua) {
            if (this.datosEmpleadoCamara == undefined) {
              this.infoCamara = `Empleado no reconocido — Similitud: ${porcentaje}%`;
            } else {
              if (!this.datosEmpleadoCamara) return;
              this.aplicarEstilos = false;
              this.infoCamara = `Empleado reconocido: ${nombreEmpleado(this.datosEmpleadoCamara)} — Similitud: ${porcentaje}%`;
            }
            return;
          }

          this.comparaciones.push({
            fotoRegistrada,
            idFotoRegistrada: idCf,
            fotoTomada: fotoCapturada,
            similitud: `${porcentaje}%`,
            nombrePunto: nombrePuntoDeAcceso,
          });
          this.comparaciones.sort((a, b) => parseFloat(a.similitud) - parseFloat(b.similitud));
          this.fotoTomada = this.comparaciones[0].fotoTomada;
          this.infoCamara = `Imágenes validadas exitosamente`;
          this.mostrarFotoTomada = true;
          this.similitudEmpleadoActual = ` — Similitud: ${porcentaje}%`;
        }, (err: Error) => {
          this.infoCamara = 'Error al cargar la imagen de verificación';
          console.error('Error en el reconocimiento facial:', err.message);
          return err;
        }
      );
    }
  }

  public abrirModal(template: TemplateRef<any>, idFoto: string, foto64: string) {
    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered modal-lg'});
    this.idFotoSeleccionada = idFoto;
    this.fotoSeleccionada = foto64;
  }

   public eliminarImagen(idImagen: string) {
    this.cargando = true;
    this.reconocimientoFacialService.empleadoEliminarFoto(this.empleado.id, idImagen).subscribe(
      (respuesta: IRespuestaChecker) => {
        if (respuesta.code == 100) {
          this.modalRef?.hide();
          mostrarSwalConfirm('La imagen ha sido eliminada', 'success');
          this.idFotoSeleccionada = '';
          this.mostrarEmpleados.emit(true);
        } else {
          mostrarSwalError('Error', `No ha sido posible eliminar la imagen. Código: ${respuesta.code}, Mensaje: ${respuesta.mensaje}`);
        }
        this.cargando = false;
      }, (error) => {
        console.error(error);
        let err: string = error.error;
        this.accesoDatosService.logAgrega2("Error al eliminar la imagen del empleados RF. " + err);
        mostrarSwalError('Error', 'Error al eliminar la imagen del empleado RF');
        this.cargando = false;
      }
    );
  }

  public guardarFoto(foto64: string) {
    this.infoCamara = 'Guardando datos en el servidor...';
    this.nomiExpressApi.enviarDatosEmpleado(+this.empleado.id, 'ep', foto64, this.similitudGuardar, this.respuestaGuardar).subscribe(
      (respuesta: IRespuestaChecker) => {
        if (respuesta.code === 100) {
          mostrarSwalToast('Imagen guardada como registro facial', 'success');
          this.mostrarEmpleados.emit(true);
        } else {
          mostrarSwalError('Error al guardar foto', `Código: ${respuesta.code}, Mensaje: ${respuesta.mensaje}`);
        }
      },
      (error: Error) => {
        console.error('Error al guardar la foto:', error);
        const mensajeError = error.message || 'Error desconocido';
        mostrarSwalError('Error al guardar foto', mensajeError);
      }
    );
  }

  public verificaContinua() {
    this.limpiarDatosDeToma();
    this.infoCamara = 'Iniciando verificación continua...'
    this.verificacionContinua = true;
    this.intervalId = setInterval(() => {
      this.tomarFoto();
    }, 1500);
  }

  public detenerVerificaContinua() {
    this.verificacionContinua = false;
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  public volverIncidencias() {
    this.cerrarVerificarFoto.emit();
    this.mostrarEmpleados.emit(false);
    this.limpiarDatosDeToma();
  }

  public cargarEmpleadoPorId(empleadoId: number): void {
    this.accesoDatosService.empleadoObtenerRF_id(empleadoId).subscribe(
      (empleado: IEmpleadoRF) => {
        this.empleado = {
          ...nuevoEmpleado(),
          id: empleadoId.toString(),
          nombre: empleado.empleado.nombre,
          paterno: empleado.empleado.paterno,
          materno: empleado.empleado.materno,
        };
        console.log('Datos completos del empleado cargados:', this.empleado);
      },
      (error) => {
        console.error('Error al cargar los datos del empleado:', error);
      }
    );
  }

  ngOnInit(): void {
    this.cargando = true;
    this.accesoExpress = this.nomiExpressApi.accesoExpress();
    this.camaraAlto = this.accesoExpress.camaraEmpleados;
    this.camaraAncho = this.accesoExpress.camaraEmpleados;
    if (isNaN(this.camaraAncho)) this.camaraAncho = 400;
    if (isNaN(this.camaraAlto)) this.camaraAlto = 400;
    this.esDebugger = !environment.production || this.accesoExpress.debug;
    this.empleado.id = this.accesoDatosService.empleadoActualObtener().toString();
    this.cargarEmpleadoPorId(+this.empleado.id);
    this.cargarEmpleado(false);
    this.cargarEmpleados();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fotoTomada'] && changes['fotoTomada'].currentValue) {
      this.verificarEmpleado(this.fotoTomada);
    }
  }
}
